"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _q = _interopRequireDefault(require("q"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _requestKeys = require("lead-flows-ui/earlyRequest/requestKeys");

var _utils = require("lead-flows-ui/earlyRequest/utils");

var BASE_URL = '/lead-flows/v1/lead-flows';
var MAX_LIMIT = 200; // TODO: Fix the UI to make smaller queries and do pagination client-side

var TIME_LIMIT = 60000;
var _default = {
  fetchDynos: function fetchDynos() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var count = arguments.length > 1 ? arguments[1] : undefined;
    var searchTerm = arguments.length > 2 ? arguments[2] : undefined;
    var limit = count || MAX_LIMIT;
    return _apiClient.default.get(BASE_URL, {
      timeout: TIME_LIMIT,
      query: {
        clienttimeout: TIME_LIMIT,
        limit: limit,
        name__contains: searchTerm,
        offset: offset,
        order: '-created_at'
      }
    });
  },
  _fetchDyno: function _fetchDyno(id) {
    return _apiClient.default.get(BASE_URL + "/" + id);
  },
  fetchDyno: function fetchDyno(id) {
    var _this = this;

    var earlyRequest = window.earlyRequester && window.earlyRequester.getRequestStateByName((0, _requestKeys.getFetchKey)(id));

    if (earlyRequest) {
      return new _q.default.Promise(function (resolve) {
        earlyRequest.whenFinished(function (data) {
          (0, _utils.cleanEarlyRequests)((0, _requestKeys.getFetchKey)(id));
          return resolve(data);
        });
        earlyRequest.onError(function () {
          return resolve(_this._fetchDyno(id));
        });
      });
    }

    return this._fetchDyno(id);
  },
  fetchDynoByGuid: function fetchDynoByGuid(guid) {
    return this.fetchDyno(guid);
  },
  createDyno: function createDyno(dyno) {
    return _apiClient.default.post(BASE_URL, {
      data: dyno
    });
  },
  cloneDyno: function cloneDyno(id, name) {
    return _apiClient.default.post(BASE_URL + "/" + id + "/clone", {
      data: {
        name: name
      }
    });
  },
  putDyno: function putDyno(dyno) {
    return _apiClient.default.put(BASE_URL + "/" + dyno.id, {
      data: dyno,
      query: {
        if_unmodified_since_ticks: dyno.updatedAt
      }
    });
  },
  partialUpdateDyno: function partialUpdateDyno(dyno) {
    return _apiClient.default.patch(BASE_URL + "/" + dyno.id, {
      data: dyno,
      query: {
        if_unmodified_since_ticks: dyno.updatedAt
      }
    });
  },
  putDynoAsDraft: function putDynoAsDraft(dyno) {
    return _apiClient.default.put(BASE_URL + "/drafts/" + dyno.id, {
      data: dyno,
      query: {
        includeDiff: true,
        if_unmodified_since_ticks: dyno.updatedAt
      }
    });
  },
  _getDynoDraft: function _getDynoDraft(dyno) {
    return _apiClient.default.get(BASE_URL + "/drafts/" + dyno.id, {
      query: {
        includeDiff: true
      }
    });
  },
  getDynoDraft: function getDynoDraft(_ref) {
    var _this2 = this;

    var id = _ref.id;
    var earlyRequest = window.earlyRequester && window.earlyRequester.getRequestStateByName((0, _requestKeys.getFetchDraftKey)(id));

    if (earlyRequest) {
      return new _q.default.Promise(function (resolve) {
        earlyRequest.whenFinished(function (data) {
          (0, _utils.cleanEarlyRequests)((0, _requestKeys.getFetchDraftKey)(id));
          return resolve(data);
        });
        earlyRequest.onError(function () {
          return resolve(_this2._getDynoDraft({
            id: id
          }));
        });
      });
    }

    return this._getDynoDraft({
      id: id
    });
  },
  deleteDyno: function deleteDyno(id) {
    return _apiClient.default.delete(BASE_URL + "/" + id);
  },
  deleteDynoDraft: function deleteDynoDraft(id) {
    return _apiClient.default.delete(BASE_URL + "/drafts/" + id);
  },
  fetchKickbackPreview: function fetchKickbackPreview(id, emailData, locale) {
    return _apiClient.default.get(BASE_URL + "/kickback/preview", {
      query: (0, _extends2.default)({}, emailData, {
        locale: locale
      })
    });
  },
  fetchDynoRevisions: function fetchDynoRevisions(id, start, end) {
    return _apiClient.default.get("/lead-flows/v1/revisions/" + id, {
      query: {
        start: start.valueOf(),
        end: end.valueOf(),
        diff: true
      }
    });
  }
};
exports.default = _default;
module.exports = exports.default;